/**
 *
 * Asynchronously loads the component for BillingActionsDetails Page
 *
 */

import { lazyLoad } from 'utils/loadable';

export const BillingActionsDetailsPage = lazyLoad(
  () => import('./index'),
  module => module.BillingActionsDetailsPage,
);
